import React from 'react';
import Intro from '../components/Intro';
import About from '../components/About';
import Projects from '../components/Projects';
import Blog from '../components/Blog';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <div className="relative w-full bg-black text-gray-300 min-h-screen">
      <div className="w-full">
        <Intro />
        <About />
        <Projects />
        <Blog />
        <Contact />
      </div>

      {/* Subtle Background Grid Effect */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5 pointer-events-none" />
    </div>
  );
};

export default Home;